import React, {Component} from 'react'

class Error extends Component{
    state = {}
    render(){
        return (
            <h1>404 Ruta no encontrada</h1>
        )
    }
}

export default Error;